import React, { useContext } from 'react';
import { ContactDetailsFormValue, EditContactDetailsContext } from './EditContactDetailsContext';
import { getIntl } from '../../../../../utils/intl';
import ContactDetailsForm, { ContactDetailField } from '../../../../shared/ContactDetailsForm';

const intl = getIntl('contactDetails.editStep2', {
    submit: 'Save & Exit',
    profileInformationContactInformation: 'Contact Information',
});

const step2ContactDetailsFields: ContactDetailField[] = [
    'address1',
    'address2',
    'city',
    'state',
    'zipCode',
    'email',
    'phoneNumber',
];

export type EditStep2OwnProps = {};

export type EditStep2Props = EditStep2OwnProps;

const EditStep2: React.FC<EditStep2Props> = () => {
    const { contactDetails, onComplete, isUpdating } = useContext(EditContactDetailsContext);

    return (
        <ContactDetailsForm
            key={JSON.stringify(contactDetails)}
            isDisabled={isUpdating}
            initialValues={contactDetails}
            fields={step2ContactDetailsFields}
            required={[]}
            submitButtonTitle={intl('submit')}
            isSubmitting={isUpdating}
            extraFieldNames={['avatar']}
            onSubmit={(values) => {
                onComplete(values as ContactDetailsFormValue);
            }}
        />
    );
};

export default React.memo(EditStep2);
